import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { getMachineCountingProfiles } from '@reducers/machines';
import { MachineCountingProfile } from '@api/domain';
import { useFetch } from '@api/hooks/useFetch';

export const useGetMachineCountingProfiles = () => {
  const dispatch = useAppDispatch();

  const {
    data: machineCountingProfiles,
    loading,
    refetch,
  } = useFetch<MachineCountingProfile[]>({
    fetchFn: async () => {
      const response = await dispatch(getMachineCountingProfiles());
      return response || null;
    },
    deps: [],
  });

  return { machineCountingProfiles, loading, refetch };
};
